import React from 'react'
import moment from 'moment'
import numeral from 'numeral'
import NumberFormat from '../../../components/NumberFormat'
import ValueMovement from '../../../components/ValueMovement'
import KeyMetrics from '../components/KeyMetrics'

const CustomTooltip = ({ label, value }) => (
    <div className="custom-tooltip">
        <span>
            <strong>{label}:</strong>
        </span>
        <span style={{ marginLeft: 10 }}>{value}</span>
    </div>
)

const UniqueBrowsersTab = {
    label: 'Unique Browsers',
    tickFormatter: value => numeral(value).format('0[.]0a'),
    renderTab: ({
        // eslint-disable-next-line
        uniqueBrowsers: { total, changeToCumulativeTotalSinceYesterday },
    }) => (
        <div className="key-value">
            <NumberFormat value={total} />
            <ValueMovement
                value={changeToCumulativeTotalSinceYesterday}
                component={NumberFormat}
            />
        </div>
    ),
    tooltip: ({ active, payload, label }) =>
        active && payload && payload.length > 0 ? (
            <CustomTooltip
                label={moment(label).format('DD MMM YYYY')}
                value={Math.floor(payload[0].value)}
            />
        ) : null,
    mapDataForChart: data =>
        Object.keys(data.groups).map(groupDate => ({
            x: groupDate,
            y: data.groups[groupDate].uniqueBrowsers,
        })),
}

const PageViewsTab = {
    label: 'Page Views',
    tickFormatter: value => numeral(value).format('0[.]0a'),
    renderTab: ({
        pageViews: { total, changeToCumulativeTotalSinceYesterday },
    }) => (
        <div className="key-value">
            <NumberFormat value={total} />
            <ValueMovement
                value={changeToCumulativeTotalSinceYesterday}
                component={NumberFormat}
            />
        </div>
    ),
    tooltip: ({ active, payload, label }) =>
        active && payload && payload.length > 0 ? (
            <CustomTooltip
                label={moment(label).format('DD MMM YYYY')}
                value={Math.floor(payload[0].value)}
            />
        ) : null,
    mapDataForChart: data =>
        Object.keys(data.groups).map(groupDate => ({
            x: groupDate,
            y: data.groups[groupDate].pageViews,
        })),
}

const selections = [UniqueBrowsersTab, PageViewsTab]

const KeyMetricsVisits = props => (
    <KeyMetrics {...props} selections={selections} data={props.data} />
)

export default KeyMetricsVisits
